// extracted by mini-css-extract-plugin
module.exports = {"pagination":"Pagination_pagination__e9RbQ","paginationWrapper":"Pagination_paginationWrapper__lydcg","paginationInfo":"Pagination_paginationInfo__TyIN4"};